module.exports = __webpack_public_path__ + "img/tylenol_regular_strength_tablets.fee67e0d.jpeg";